import {
  MicrophonePermissionStatus,
  PhoneStatus,
  TransportConnectionState,
} from '~/types/WebphoneTypes'

import { RegistererState } from '@mangovoice/sip'
import { PhoneCallStatus } from '@mangovoice/types'

export const getPhoneStatus = (
  registration: RegistererState,
  transportConnectionState: TransportConnectionState,
  microphonePermissions: MicrophonePermissionStatus,
  activeCallStatus: PhoneCallStatus | null,
): PhoneStatus => {
  if (registration === RegistererState.Initial) {
    return PhoneStatus.INITIAL
  }
  if (transportConnectionState === TransportConnectionState.DISCONNECTED) {
    return PhoneStatus.TRANSPORT_DISCONNECTED
  }
  if (
    registration === RegistererState.Unregistered ||
    registration === RegistererState.Terminated
  ) {
    return PhoneStatus.ERROR
  }
  if (microphonePermissions === MicrophonePermissionStatus.DENIED) {
    return PhoneStatus.MIC_DENIED
  }
  if (
    activeCallStatus === PhoneCallStatus.INITIAL ||
    activeCallStatus === PhoneCallStatus.CONNECTING
  ) {
    return PhoneStatus.CALL_CONNECTING
  }
  if (activeCallStatus === PhoneCallStatus.RINGING) {
    return PhoneStatus.RINGING
  }
  if (activeCallStatus === PhoneCallStatus.CONNECTED) {
    return PhoneStatus.CALL_ACTIVE
  }
  return PhoneStatus.READY
}
